define('PartApplication.EntryPoint',
	[
		'PartApplication.PDP.View',
		'PartApplication.Model',
		'Cart.AddToCart.Button.View',
		'LiveOrder.Line.Model',
		'InstrumentationAddToCart',
		'Cart.Confirmation.Helpers',
		'Loggers',
		'Facets.ItemCell.View',
		'Facets.Browse.View',
		'Profile.Model',
		'Utils',
		'Handlebars',
		'AjaxRequestsKiller',
		'underscore'
	],
	function (
		PartApplicationPDPView,
		PartApplicationModel,
		CartAddToCartButtonView,
		LiveOrderLineModel,
		InstrumentationAddToCart,
		CartConfirmationHelpers,
		Loggers,
		FacetsItemCellView,
		FacetsBrowseView,
		ProfileModel,
		Utils,
		Handlebars,
		AjaxRequestsKiller,
		_
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				var plpComponent = container.getComponent('PLP');
				this.model = new PartApplicationModel();
				var self = this;
				self.options = Utils.parseUrlOptions(window.location.hash != '' ? window.location.hash : window.location.search);
				self.vehicleData = {
					year: self.options.year,
					make: self.options.make,
					model: reformatModel(self.options.model),
					isFromYMM: true
				};

				if (layout) {
					layout.addChildView('Quantity.Pricing', function () {
						var view = new PartApplicationPDPView({
							container: container,
							model: self.model,
							vehicleData: self.vehicleData.isFromYMM ? self.vehicleData : {}
						});
						self.vehicleData.isFromYMM = false;
						return view;
					});
				}

				_.extend(CartAddToCartButtonView.prototype, {
					addToCart: function(e){

						try {
							setTimeout(function() {
								for (var i = 0; i < document.getElementsByClassName('bx-pager-link').length; i++) {
									var activeImgOptionURL = ((
										document.getElementsByClassName('bx-pager-link')[i].children[0]
									)).currentSrc.split('?')[0];
									var mainImg = document.getElementsByClassName(
										'product-details-image-gallery-container'
									)[i + 1].innerHTML;
									var mainImgSplit = mainImg.split(' ');
									var mainImgSplitURL = mainImgSplit[1].split('?');
				
									if (mainImgSplitURL[0] != 'src="' + activeImgOptionURL) {
										mainImgSplitURL[0] = 'src=' + activeImgOptionURL;
										mainImgSplit[1] = mainImgSplitURL.join('?');
										var newImgSrc = mainImgSplit.join(' ');
										document.getElementsByClassName('product-details-image-gallery-container')[
											i + 1
										].innerHTML = newImgSrc;
									}
								}
							}, 3000);
						} catch (e) {
							console.warn(
								'The Zoom bug fix is throwing an error (Cart.AddToCart.Button.View): ' +
									JSON.stringify(e)
							);
						}
						e.preventDefault();
						var self = this;
						var cart_promise;
				
						if (
							!this.model.areAttributesValid(['options', 'quantity'], self.getAddToCartValidators())
						) {
							return;
						}
				
						if (!this.model.isNew() && this.model.get('source') === 'cart') {
							cart_promise = this.cart.updateProduct(this.model);
							cart_promise.done(function() {
								self.options.application.getLayout().closeModal();
							});
						} else {
							var line = LiveOrderLineModel.createFromProduct(this.model);

							var options = line.get('options') && line.get('options').models;

							var params = Utils.parseUrlOptions(window.location.hash != '' ? window.location.hash : window.location.search);
							var item = line.get('item');

							_.map(options, function (option){
								var optionId = option.get('cartOptionId');
								if(optionId == 'custcol_rp_vehicle') option.set('value',{ 'label': params.year+ '-' +params.make+ '-' + params.model, 'internalid': params.year+ '-' +params.make+ '-' + params.model});
								if(optionId == 'custcol_rp_part_location') option.set('value', { 'label': item.get('location'), 'internalid': item.get('location')});
								if(optionId == 'custcol_rp_part_application') option.set('value',{ 'label': item.get('partApplicationId'), 'internalid': item.get('partApplicationId')});
							});

							var itemTrack = InstrumentationAddToCart.itemToTrack(line);
							var loggers = Loggers.Loggers.getLogger(); //sacar loggers
							var actionId = loggers.start('Add to Cart');
							cart_promise = this.cart.addLine(line);
							cart_promise.then(() => {
								var addToCartOperationIds = InstrumentationAddToCart.getAddToCartOperationId(
									this.cart.get('lines').models,
									line
								);
								loggers.end(actionId, {
									operationIds: addToCartOperationIds,
									status: 'success',
									itemId: itemTrack.itemId,
									itemQuantity: itemTrack.itemQuantity
								});
							});
				
							CartConfirmationHelpers.showCartConfirmation(
								cart_promise,
								line,
								self.options.application
							);
						}
				
						cart_promise.fail(function(jqXhr) {
							var error_details = null;
							try {
								if (jqXhr && jqXhr.responseText) {
									var response = JSON.parse(jqXhr.responseText);
									error_details = response.errorDetails;
								}
							} catch (error) {
								console.error(error);
							} finally {
								if (error_details && error_details.status === 'LINE_ROLLBACK') {
									self.model.set('internalid', error_details.newLineId);
								}
							}
						});
				
						this.disableElementsOnPromise(cart_promise, e.target);
						return false;
					}
				});

				_.extend(FacetsItemCellView.prototype, {

					getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn, e) {
						var ret = fn.apply(this, _.toArray(arguments).slice(1));
						ret.location = this.model.get('location');
						ret.haveLocation = !!this.model.get('haveLocation');

						ret.partApplication = this.model.get('partApplication');
						ret.havePartApplication = !!this.model.get('havePartApplication');

						ret.comment = this.model.get('comment');
						ret.haveComment = !!this.model.get('haveComment');

						ret.partType = this.model.get('partType');
						ret.havePartType = !!this.model.get('havePartType');

						ret.masterPartNumber = this.model.get('masterPartNumber');
						ret.haveMasterPartNumber = !!this.model.get('haveMasterPartNumber');
						if (!ret.masterPartNumber) {
							ret.masterPartNumber = this.model.get('custitem_masterpartref');
							ret.haveMasterPartNumber = !!this.model.get('custitem_masterpartref');
						}

						if (this.model.get('itemQuantityInformation')) {
							ret.quantityAvailableInformation = this.model.get('itemQuantityInformation');
						}

						ret.webStoreDescription = this.model.get('storedescription2');
						ret.haveWebStoreDescription = !!this.model.get('haveWebStoreDescription');

						return ret;
					})
				});

				var partApplicationCtx = this;

				_.extend(FacetsBrowseView.prototype, {
					beforeShowContent: function () {
						var promise = jQuery.Deferred();

						// if prices aren't to be shown we take out price related facet
						// and clean up the url
						if (ProfileModel.getInstance().hidePrices()) {
							this.translator = this.translator.cloneWithoutFacetId('onlinecustomerprice');
						}

						var self = this;
						var models = [this.model];
						var categoryModel = this.model.get('category');

						if (categoryModel) {
							models.push(categoryModel);
						}

						var apiParams = self.translator.getApiParams();
						var page = self.translator.options.page;
						var limit = apiParams.limit;
						var offset = apiParams.offset;
						var sort = apiParams.sort;
						if (apiParams.model || apiParams.make || apiParams.year) {
							// Refresh vehicleData with THIS search's real values (not the
							// stale mountToApp-time snapshot) and re-arm isFromYMM, so the
							// next PDP viewed reflects the vehicle just searched for.
							partApplicationCtx.vehicleData = {
								year: apiParams.year,
								make: reformatModel(decodeURIComponent(apiParams.make)),
								model: reformatModel(decodeURIComponent(apiParams.model)),
								isFromYMM: true
							};
							partApplicationCtx.model.fetch({
								data: {
									year: apiParams.year,
									make: reformatModel(decodeURIComponent(apiParams.make)),
									model: reformatModel(decodeURIComponent(apiParams.model)),
									limit: limit,
									offset: offset,
									sort: sort,
									page: page
								},
								killerId: AjaxRequestsKiller.getKillerId()
							}).done(function (response) {
								self.totalRecordsFound = response.totalRecords;
								var ids = response.itemsId;
								self.partAppItems = response.result;
								ids = _.uniq(ids, function (id) {
									return id.id;
								});

								self.ids = _.pluck(ids, 'id').join();
								jQuery.when
									.apply(null, _.invoke(models, 'fetch', {
										data: {
											id: self.ids || [],
										}
									}))
									.then(function (facetResponse) {
										facetResponse = categoryModel ? facetResponse[0] : facetResponse;

										if (facetResponse.corrections && facetResponse.corrections.length > 0) {
											var unaliased_url = self.router.unaliasUrl(null, facetResponse.corrections);
											promise.reject();

											if (SC.ENVIRONMENT.jsEnvironment === 'server') {
												nsglobal.statusCode = 301;
												nsglobal.location = '/' + unaliased_url;
											} else {
												Backbone.history.navigate('#' + unaliased_url, { trigger: true });
											}
										} else {
											self.translator.setLabelsFromFacets(self.model.get('facets') || []);

											if (sort) {
												var splitted = sort.split(':');
												var sortField = splitted[0];
												var sortOrder = splitted[1] == 'asc' ? false : true;

												if (sortField != 'relevance') {
													sortField = sortField == 'storedisplayname' ? 'storedisplayname2' : sortField;
													self.model.get('items').models = _.sortBy(self.model.get('items').models, function (elem) { return elem.attributes[sortField] });
												} else {
													self.model.get('items').models = _.sortBy(self.model.get('items').models, function (elem) { return elem.attributes.storedisplayname2 });
												}

												if (sortOrder) {
													self.model.get('items').models = self.model.get('items').models.reverse();
												}
											}


											var itemsOnCollection = self.model.get('items').models;
											var itemsToShow = [];
											_.each(itemsOnCollection, function (item) {
												var partApplicationItem = _.find(self.partAppItems, function (partAppItem) { return partAppItem.itemId == item.get('internalid') });
												if (partApplicationItem) {
													itemsToShow.push(item);
													var partLocationSplit = partApplicationItem.location.split("||").length > 1 ? partApplicationItem.location.split("||") : partApplicationItem.location.split(" ");
													var location = partLocationSplit.join(', ');
													item.set('location', location);
													item.set('haveLocation', location.length > 0 ? true : false);

													var partApplicationSplit = partApplicationItem.partApplication.split("||");
													item.set('partApplication', partApplicationSplit);
													item.set('havePartApplication', partApplicationSplit.length > 0 && partApplicationSplit[0] != '' ? true : false);

													item.set('partApplicationId', partApplicationItem.partApplicationId);
													item.set('havePartApplicationId', !!partApplicationItem.partApplicationId);

													item.set('comment', partApplicationItem.comment);
													item.set('haveComment', !!partApplicationItem.comment);

													item.set('partType', partApplicationItem.partType);
													item.set('haveComment', !!partApplicationItem.partType);

													item.set('masterPartNumber', partApplicationItem.masterPartNumber);
													item.set('haveMasterPartNumber', !!partApplicationItem.masterPartNumber);

													item.set('webStoreDescription', item.get('storedescription2'));
													item.set('haveWebStoreDescription', !!item.get('storedescription2'));

													item.set('itemQuantityInformation', partApplicationItem.itemQuantityInformation);
												}
											});
											self.model.set('total', self.totalRecordsFound);
											promise.resolve();
										}
									})
									.fail(function (jqXhr) {
										promise.reject();

										if (jqXhr.status === '404') {
											self.application.getLayout().notFound();
										}
									});
							});
						} else {
							//Type ahead or quick add -- also where a plain keyword/direct
							// search lands (no year/make/model in this navigation's URL).
							// Clear any vehicle info left over from a prior YMM search so
							// the next PDP viewed doesn't show a stale, unrelated vehicle.
							partApplicationCtx.vehicleData = {
								year: null,
								make: null,
								model: null,
								isFromYMM: false
							};
							jQuery.when
								.apply(null, _.invoke(models, 'fetch', {}))
								.then(function (facetResponse) {
									facetResponse = categoryModel ? facetResponse[0] : facetResponse;

									if (facetResponse.corrections && facetResponse.corrections.length > 0) {
										var unaliased_url = self.router.unaliasUrl(null, facetResponse.corrections);
										promise.reject();

										if (SC.ENVIRONMENT.jsEnvironment === 'server') {
											nsglobal.statusCode = 301;
											nsglobal.location = '/' + unaliased_url;
										} else {
											Backbone.history.navigate('#' + unaliased_url, { trigger: true });
										}
									} else {
										self.translator.setLabelsFromFacets(self.model.get('facets') || []);

										// Keyword/direct search never calls the YMM fitment service, so
										// itemQuantityInformation (what StockInformation's PLP grid-cell
										// logic requires to compute stockMessage) was never being set here
										// -- even though the plain item search response already carries a
										// native quantityavailable field per item. Map it into the same
										// shape the YMM branch above produces, so the stock message shows
										// on keyword-search results too.
										var itemsOnCollection = self.model.get('items').models;
										_.each(itemsOnCollection, function (item) {
											var qtyAvailable = item.get('quantityavailable');
											if (qtyAvailable !== undefined && qtyAvailable !== null) {
												item.set('itemQuantityInformation', [{ availableQuantity: qtyAvailable }]);
											}
										});

										promise.resolve();
									}
								})
								.fail(function (jqXhr) {
									promise.reject();

									if (jqXhr.status === '404') {
										self.application.getLayout().notFound();
									}
								});
						}

						return promise;
					}
				});

				Handlebars.registerHelper('ifNotCart', function (options) {
					var hash = document.location.href;
					if (hash.indexOf('cart') == -1) {
						return options.fn(this);
					}
					return options.inverse(this);
				});

			}
		};

		function reformatModel(model) {
			var replaceableCharacters = [
				{ character: '-SLASH-', encodedValue: '/' },
				{ character: '-AND-', encodedValue: '&(?!amp;)' },
				{ character: '%2C', encodedValue: ',' },
				{ character: '%27', encodedValue: "'" },
				{ character: 'GTV6', encodedValue: 'GTV-6' },
				{ character: '-', encodedValue: ' ' },
				{ character: '~', encodedValue: '-' }
			];

			var valueToReturn = model;
			_.each(replaceableCharacters, function (replaceableCharacter) {
				var expression = new RegExp(replaceableCharacter.character, "g");
				valueToReturn = valueToReturn ? valueToReturn.replace(expression, replaceableCharacter.encodedValue) : valueToReturn
			});
			return valueToReturn;
		}
	});
